import NavigationScroll from "../components/navigation";
import React from "react";

function TeamPage() {
    return (
        <>
            <NavigationScroll/>
            <div className="page">

                <div className="container-center">
                    <div className="top-section">
                        <h1>Meet the Team</h1>
                    </div>
                    <div className="team-section">
                        <div className="team-section-entry">
                            <img className="team-member-img" src="/img/vadim.webp"/>
                            <h2>Vadim Chernov</h2>
                            <h4>Chief Operations Officer</h4>
                        </div>
                        <div className="team-section-entry">
                            <img className="team-member-img" src="/img/alex.png"/>
                            <h2>Alexandra Sieger</h2>
                            <h4>Chief Executive Officer</h4>
                        </div>
                        <div className="team-section-entry">
                            <img className="team-member-img" src="/img/vladimir.webp"/>
                            <h2>Vladimir Chernov</h2>
                            <h4>Chief Technology Officer</h4>
                        </div>
                    </div>
                    <div className="bottom-section">

                        <h3>Whatever your need, we can solve IT.</h3>

                        <h5>Book a consultation through</h5>
                        <h5><a href="mailto:info@iextrem.com">info@iextrem.com</a></h5>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TeamPage;
